import { scale } from "@/constants/palette";
import React, { useState } from "react";

const INTERVIEW_YOUTUBE_ID = "9vreZ9Blxoc";

const CASES = [
  {
    year: "'26",
    school: "홍대부속초등학교",
    desc: "방과후 AI교육 길잡이별 검사·특강 단독 운영 ('25~'26 연속)",
  },
  {
    year: "'25",
    school: "성곡중학교",
    desc: "가톨릭대 RISE 사업·부천시 길잡이별 검사·특강 패키지 운영",
  },
  {
    year: "'25",
    school: "안천초등학교 · 서초스마트유스센터",
    desc: "SW·AI교육·길잡이별 검사 패키지 운영",
  },
  {
    year: "'24",
    school: "망원초등학교",
    desc: "AI교육 정규 차시 내 길잡이별 검사 도입",
  },
];

/** 인증 원형 도장. 네 줄(머리말·본문·기관·부연)이 모두 도장 안에 들어갑니다. */
const SEALS = [
  {
    top: "2026 KERIS",
    mid: "실증 사업 선정",
    bottom: "부산 에듀테크 소프트랩",
    sub: "실증 진행 중",
  },
  {
    top: "2025 RISE",
    mid: "우수 사례 선정",
    bottom: "CUK-GAIA Alliance",
    sub: "산학협력 성공 사례",
  },
  {
    top: "2025 기술",
    mid: "특허 출원 완료",
    bottom: "미래 역량 진단 시스템",
    sub: "10-2025-0130902",
  },
];

const SealStar = () => (
  <svg className="s-star" width="16" height="16" viewBox="0 0 24 24" fill={scale.amber[300]} aria-hidden="true">
    <path d="M12 2.5l2.7 5.5 6 .9-4.35 4.24 1.03 6-5.38-2.83L6.62 19.13l1.03-6L3.3 8.9l6-.9z" />
  </svg>
);

/**
 * 화면 3, 사업 실증.
 *
 * 좌: 도입 사례 + 인증 도장 / 우: 지표 2개 + 교사 인터뷰(인용 + 영상).
 * 인터뷰 영상은 썸네일을 먼저 보여주고 클릭할 때만 유튜브 iframe 을 붙인다.
 * 초기 로딩에 유튜브 스크립트·쿠키가 끼지 않는다.
 */
export default function LandingProof() {
  const [playing, setPlaying] = useState(false);

  return (
    <section className="section proof" id="proof">
      <div className="shell">
        <div className="sec3-head">
          <h2 className="t-h2">
            이미 2,000명 이상의 학생과 함께,
            <br />
            서울·경기 학교 현장에서 검증했습니다.
          </h2>
        </div>

        <div className="proof-grid">
          <div className="cases-col">
            <p className="block-title">주요 도입 사례</p>
            <ul className="case-list">
              {CASES.map((item) => (
                <li key={item.school}>
                  <span className="yr">{item.year}</span>
                  <div>
                    <b>{item.school}</b>
                    <p>{item.desc}</p>
                  </div>
                </li>
              ))}
            </ul>

            <div className="seal-row">
              {SEALS.map((seal) => (
                <div className="seal-item" key={seal.mid}>
                  <span className="seal">
                    <SealStar />
                    <span className="s-top">{seal.top}</span>
                    <span className="s-mid">{seal.mid}</span>
                    <span className="s-bot">{seal.bottom}</span>
                    <span className="s-sub">{seal.sub}</span>
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div className="interview">
            <dl className="stat-cards">
              <div className="stat-card">
                <dd>
                  2,000<span className="plus">+</span>
                </dd>
                <dt>누적 응시 학생 수</dt>
              </div>
              <div className="stat-card">
                <dd>
                  4.65<span className="of">/5</span>
                </dd>
                <dt>프로그램 만족도</dt>
              </div>
            </dl>

            <p className="interview-quote">
              &ldquo;처음 겪는 유형의 검사라 새로웠고, AI시대에 진로 방향을 잡는 데 도움이
              되었다.&rdquo;
            </p>

            <div className="interview-video">
              {playing ? (
                <iframe
                  src={`https://www.youtube-nocookie.com/embed/${INTERVIEW_YOUTUBE_ID}?autoplay=1&rel=0`}
                  title="해봄 참여 교사 인터뷰"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              ) : (
                <button
                  type="button"
                  className="iv-facade"
                  aria-label="해봄 참여 교사 인터뷰 영상 재생"
                  onClick={() => setPlaying(true)}
                >
                  {/* eslint-disable-next-line @next/next/no-img-element */}
                  <img
                    src="/images/landing/sec3-interview.jpg"
                    alt="해봄 참여 교사 인터뷰 썸네일"
                    loading="lazy"
                  />
                  <span className="iv-play" aria-hidden="true">
                    <svg width="18" height="20" viewBox="0 0 18 20" style={{ marginLeft: 3 }}>
                      <path d="M0 0v20l18-10z" fill="#fff" />
                    </svg>
                  </span>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
